import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  AccessTime as AttendanceIcon,
  Assessment as ReportIcon,
  Settings as SettingsIcon,
  MoreVert as MoreVertIcon,
  Refresh as RefreshIcon,
  Download as DownloadIcon,
  Print as PrintIcon
} from '@mui/icons-material';
import StudentAttendance from './studentAttendance';
import StudentAttendanceReports from './studentAttendanceReports';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`student-attendance-tabpanel-${index}`}
      aria-labelledby={`student-attendance-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function StudentAttendanceDashboard() {
  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleExport = () => {
    // Export functionality
    handleMenuClose();
  };

  const handlePrint = () => {
    // Print functionality
    window.print();
    handleMenuClose();
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Header */}
      <AppBar position="static" sx={{ background: 'linear-gradient(315deg, #17dddd 0%, #1760d3 74%)' }}>
        <Toolbar>
          <AttendanceIcon sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Student Attendance Management System
          </Typography>
          <IconButton
            color="inherit"
            onClick={handleMenuClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleRefresh}>
              <ListItemIcon>
                <RefreshIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Refresh</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleExport}>
              <ListItemIcon>
                <DownloadIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Export Data</ListItemText>
            </MenuItem>
            <MenuItem onClick={handlePrint}>
              <ListItemIcon>
                <PrintIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Print</ListItemText>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Tabs */}
      <Paper sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="student attendance tabs"
          variant="fullWidth"
        >
          <Tab 
            icon={<AttendanceIcon />} 
            label="Mark Attendance" 
            id="student-attendance-tab-0"
            aria-controls="student-attendance-tabpanel-0"
          />
          <Tab 
            icon={<ReportIcon />} 
            label="Reports & Analytics" 
            id="student-attendance-tab-1"
            aria-controls="student-attendance-tabpanel-1"
          />
        </Tabs>
      </Paper>

      {/* Tab Panels */}
      <TabPanel value={tabValue} index={0}>
        <StudentAttendance />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <StudentAttendanceReports />
      </TabPanel>
    </Box>
  );
}
